import { render, staticRenderFns } from "./leyes.vue?vue&type=template&id=0fb85593&scoped=true"
import script from "./leyes.vue?vue&type=script&lang=js"
export * from "./leyes.vue?vue&type=script&lang=js"
import style0 from "./leyes.vue?vue&type=style&index=0&id=0fb85593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb85593",
  null
  
)

export default component.exports